<template>
  <fragment>
    <b-form-group
      class="mb-0"
      label="Contact Name"
      label-class="required"
    >
      <b-form-row>
        <b-col lg="6" sm="12">
          <b-form-group :invalid-feedback="requiredInvalidFeedback">
            <b-form-input
              id="first_name"
              class="p-3 rounded_0 border_grey height_auto v3_color_black_knight"
              v-model="$v.firstName.$model"
              :state="validateState('firstName')"
            />
            <label for="first_name" class="mb-0 v2_color_med_gray">
              First Name
            </label>
          </b-form-group>
        </b-col>
        <b-col lg="6" sm="12">
          <b-form-group :invalid-feedback="requiredInvalidFeedback">
            <b-form-input
              id="last_name"
              class="p-3 rounded_0 border_grey height_auto v3_color_black_knight"
              v-model="$v.lastName.$model"
              :state="validateState('lastName')"
            />
            <label for="last_name" class="mb-0 v2_color_med_gray">
              Last Name
            </label>
          </b-form-group>
        </b-col>
      </b-form-row>
    </b-form-group>
    <b-form-row>
      <b-col lg="6" sm="12">
        <b-form-group
          label="Company Name"
          label-class="required"
          :invalid-feedback="requiredInvalidFeedback"
        >
          <b-form-input
            id="company_name"
            class="p-3 rounded_0 border_grey height_auto v3_color_black_knight"
            v-model="$v.companyName.$model"
            :state="validateState('companyName')"
          />
        </b-form-group>
      </b-col>
      <b-col lg="6" sm="12">
        <slot name="email-input" />
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col lg="6" sm="12">
        <b-form-group
          label="Contact Phone Number"
          label-class="required"
          :invalid-feedback="phoneInvalidFeedback"
        >
          <b-form-input
            id="phone_number"
            class="p-3 rounded_0 border_grey height_auto v3_color_black_knight"
            v-model="$v.phoneNumber.$model"
            :state="validateState('phoneNumber')"
          />
        </b-form-group>
      </b-col>
      <b-col lg="6" sm="12">
        <slot name="password-input" />
      </b-col>
    </b-form-row>
    <b-form-group
      label="Company Address"
      label-class="required"
      class="mb-lg-0"
    >
      <b-form-row>
        <b-col lg="6" sm="12">
          <b-form-group :invalid-feedback="requiredInvalidFeedback">
            <b-form-input
              id="address_1"
              class="p-3 rounded_0 border_grey height_auto v3_color_black_knight"
              v-model="$v.addressLine1.$model"
              :state="validateState('addressLine1')"
            />
            <label for="address_1" class="mb-0 v2_color_med_gray">
              Address Line 1
            </label>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col lg="6" sm="12">
          <b-form-group>
            <b-form-input
              id="address_2"
              class="p-3 rounded_0 border_grey height_auto v3_color_black_knight"
              v-model="$v.addressLine2.$model"
            />
            <label for="address_2" class="mb-0 v2_color_med_gray">
              Address Line 2
            </label>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col lg="6" sm="12">
          <b-form-group :invalid-feedback="requiredInvalidFeedback">
            <b-form-input
              id="city"
              class="p-3 rounded_0 border_grey height_auto v3_color_black_knight"
              v-model="$v.city.$model"
              :state="validateState('city')"
            />
            <label for="city" class="mb-0 v2_color_med_gray">City</label>
          </b-form-group>
        </b-col>
        <b-col lg="6" sm="12">
          <v-wait :for="loaderId">
            <div
              class="d-flex justify-content-center w-100 align-items-center"
              slot="waiting"
            >
              <b-spinner />
            </div>
            <b-form-group
              class="mb-lg-0"
              :invalid-feedback="requiredInvalidFeedback"
            >
              <div class="phairify-select-wrapper">
                <b-form-select
                  id="state"
                  class="p-3 height_auto rounded_0 border_grey v3_color_black_knight"
                  v-model="$v.state.$model"
                  :options="stateOptions"
                  :state="validateState('state')"
                >
                  <template slot="first">
                    <option :value="null" disabled>
                      -- Select State --
                    </option>
                  </template>
                </b-form-select>
              </div>
            </b-form-group>
          </v-wait>
          <label for="state" class="mb-0 v2_color_med_gray">State</label>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col lg="6" sm="12">
          <b-form-group class="mb-lg-0" :invalid-feedback="zipInvalidFeedback">
            <b-form-input
              id="zip_code"
              class="rounded_0 border_grey v3_color_black_knight height_auto p-3"
              v-model="$v.zipCode.$model"
              :state="validateState('zipCode')"
            />
            <label for="zip_code" class="mb-0 v2_color_med_gray">
              Zip Code
            </label>
          </b-form-group>
        </b-col>
      </b-form-row>
    </b-form-group>
  </fragment>
</template>

<script>
import {
  helpers,
  maxLength,
  minLength,
  numeric,
  required,
} from 'vuelidate/lib/validators';
import {
  PHONE_VALIDATION_MESSAGE,
  PHONE_VALIDATION_RGEXP,
} from '@/helpers/PhoneHelpers';
import { validationMixin } from 'vuelidate';
import validateStateMixin from '@/mixins/validateStateMixin';
import SubFormValidationMethodsMixin from '@/mixins/SubFormValidationMethodsMixin';
import Api from '@/providers/Api';

const phone = helpers.regex('phone', PHONE_VALIDATION_RGEXP);

export default {
  name: 'RecruiterForm',
  mixins: [validationMixin, validateStateMixin, SubFormValidationMethodsMixin],
  props: {
    initialData: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      default: null,
    },
  },
  data: function () {
    return {
      firstName: this.initialData ? this.initialData.first_name : null,
      lastName: this.initialData ? this.initialData.last_name : null,
      companyName: this.initialData && this.initialData.profile ? this.initialData.profile.company_name : null,
      phoneNumber: this.initialData && this.initialData.profile ? this.initialData.profile.phone_number : null,
      addressLine1: this.initialData && this.initialData.profile ? this.initialData.profile.address_line_1 : null,
      addressLine2: this.initialData && this.initialData.profile ? this.initialData.profile.address_line_2 : null,
      city: this.initialData && this.initialData.profile ? this.initialData.profile.city : null,
      state: this.initialData && this.initialData.profile ? this.initialData.profile.state_id : null,
      zipCode: this.initialData ? this.initialData.practice_zip : null,
      states: [],
    };
  },
  validations: {
    firstName: { required },
    lastName: { required },
    companyName: { required },
    phoneNumber: { required, phone },
    addressLine1: { required },
    addressLine2: {},
    city: { required },
    state: { required },
    zipCode: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(5),
      numeric,
    },
  },
  created: function () {
    this.getStates();
  },
  computed: {
    requiredInvalidFeedback: function () {
      return 'This field is required.';
    },
    phoneInvalidFeedback() {
      return !this.$v.phoneNumber.phone
        ? PHONE_VALIDATION_MESSAGE
        : this.requiredInvalidFeedback;
    },
    zipInvalidFeedback: function () {
      if (!this.$v.zipCode.minLength || !this.$v.zipCode.maxLength) {
        return `Zip code should be ${this.$v.zipCode.$params.minLength.min} characters long`;
      }
      if (!this.$v.zipCode.numeric) {
        return 'Must contain only numbers';
      }
      return 'This field is required';
    },
    loaderId: function () {
      return `${this.$options.name}_loading`;
    },
    stateOptions: function () {
      return this.states.map(({ state_id, state_name }) => ({
        value: state_id,
        text: state_name,
      }));
    },
  },
  methods: {
    getStates: async function () {
      this.$wait.start(this.loaderId);
      try {
        this.states = await Api.getStates();
      } catch (e) {
        this.$toasted.error('Unable to upload states data', {
          duration: 3000,
        });
      } finally {
        this.$wait.end(this.loaderId);
      }
    },
    getData: function () {
      return {
        first_name: this.firstName,
        last_name: this.lastName,
        company_name: this.companyName,
        phone_number: this.phoneNumber,
        address_line_1: this.addressLine1,
        address_line_2: this.addressLine2,
        city: this.city,
        state_id: this.state,
        practice_zip: this.zipCode,
      };
    },
  },
};
</script>

<style lang="scss">
.required:after {
  content: '*';
  color: red;
  display: inline-block;
  margin-left: 4px;
  font-size: 26px;
  line-height: 20px;
}
.form-control {
  color: black;
}
</style>
